export const DATE_FORMATS = {
    short: 'DD.MM',
    long: 'DD.MM dddd',
    longWithYear: 'MMMM Do YYYY',
    storage: 'YYYY-MM-DD'
};




// WEBPACK FOOTER //
// ./src/constants/strings.ts